import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import styled from 'styled-components';
import { Item } from './components/Item';

var Items =
/** @class */
function (_super) {
  __extends(Items, _super);

  function Items() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderItem = function (item, idx) {
      return React.createElement(ItemLi, {
        hasIcon: !!item.icon || !!item.customNode,
        key: "nav-item-" + item.label
      }, React.createElement(Item, __assign({}, item, {
        isEdgeItem: _this.props.rightAlign ? idx === _this.props.items.length - 1 : idx === 0,
        rightAlign: _this.props.rightAlign
      })));
    };

    return _this;
  }

  Items.prototype.render = function () {
    var items = this.props.items;
    return React.createElement(StyledItems, null, items.map(this.renderItem));
  };

  return Items;
}(React.Component);

export { Items };
var StyledItems = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: center;\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n"], ["\n    align-items: center;\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n"])));
var ItemLi = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: inline-flex;\n"], ["\n    position: relative;\n    display: inline-flex;\n"])));
var templateObject_1, templateObject_2;